import { useEffect } from "react";
import { data } from "../productsData";
import SingelProduct from "./SingelProduct";
import Aos from "aos";
import "aos/dist/aos.css";
function SomeProducts() {
  //some rendom products from the data file
  useEffect(() => {
    Aos.init();
  }, []);
  const some = [data[0], data[1], data[24], data[13]];
  return (
    <div className="w-full min-h-[100vh]  pt-[80px] px-3 md:px-9 mb-[80px] overflow-hidden ">
      <h1
        data-aos-duration="1500"
        data-aos="zoom-out"
        className=" text-3xl md:text-5xl w-fit pb-5 mb-[80px] mx-auto text-black font-bold relative before:w-[50%] before:absolute before:bottom-0 before:left-[50%] before:translate-x-[-50%] before:h-[4px] before:bg-fcolor "
      >
        Quelques produits
      </h1>
      <div
        data-aos-duration="2500"
        data-aos="fade-left"
        className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 "
      >
        {some.map((ele) => {
          return <SingelProduct data={ele} key={ele.id} />;
        })}
      </div>
    </div>
  );
}

export default SomeProducts;
